import { css } from "@emotion/react";
import { MouseEventHandler, ReactNode } from "react";

import { flexColumn } from "~/lib/client/design";
import { engFont } from "~/lib/client/fonts";

type Props = {
  children: ReactNode;
  onClick?: MouseEventHandler;
  label: string;
};

const ContentBodyLayout = ({ children, onClick, label }: Props) => {
  return (
    <div css={rootStyle} onClick={onClick} className={engFont.className}>
      <div css={labelStyle}>{label}</div>
      {children}
    </div>
  );
};

const rootStyle = css`
  width: 100%;
  height: 100%;
  ${flexColumn};
`;

const labelStyle = css`
  font-weight: 600;
  font-size: 12px;
  margin-top: 0.75rem;
  padding-left: 1rem;
`;

export default ContentBodyLayout;
